import { ApiResponse, DashboardInfo } from '../../types';
import apiClient from '../api/client';

export type DashboardRange = 'today' | 'week' | 'month' | 'quarter' | 'year' | 'custom';

export interface DashboardParams {
  range?: DashboardRange;
  from?: string;
  to?: string;
}

export const dashboardService = {
  getInfoDashboard: async (params?: DashboardParams): Promise<ApiResponse<DashboardInfo>> => {
    const queryParams: Record<string, string> = {};
    if (params?.range === 'custom' && params.from && params.to) {
      queryParams.from = params.from;
      queryParams.to = params.to;
    } else if (params?.range) {
      queryParams.range = params.range;
    }
    const response = await apiClient.get<ApiResponse<DashboardInfo>>(
      '/medical-facilities/dashboard/',
      { params: queryParams }
    );
    return response.data;
  },
};

